/**
 * The icon row's ONE decision (fix D / R2): whether the 4th tile is "Review" or
 * "Tournament". A single string selector (`selectRailMode`), so a tournament
 * write cannot re-render the row inside a casual game, and the per-tile state
 * stays in the tiles (unit convention §1).
 */
import {useLiveGame} from '@/Store/liveGameStore';

import {selectRailMode} from '../../Rail/model';

export type RailActionsModel = {
  /** a tournament / arena game is on the board */
  tournament: boolean;
};

export function useRailActionsModel(): RailActionsModel {
  return {tournament: useLiveGame(selectRailMode) === 'tournament'};
}

export default useRailActionsModel;
